import Grid2 from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import type { KeyboardEventHandler } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useUserContext } from "@dexteel/mesf-core";
import { CraftsFilter } from "./craftsFilter";
import { EndFilter } from "./endFilter";
import { SearchFilter } from "./SearchFilter";
import { ExpiredFilter } from "./expiredFilter";
import { StartFilter } from "./startFilter";
import { StatusFilter } from "./statusFilter";
import { TypesFilter } from "./typesFilter";

type Props = {
	onKeyDown: KeyboardEventHandler<HTMLDivElement> | undefined;
};

export const Filters = ({ onKeyDown }: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const {
		state: { defaultAreaId },
	} = useUserContext();
	const resetFilter = () => {
		setSearchParams(new URLSearchParams(), { replace: true });
		setTimeout(() => {
			navigate(`/work-orders/${defaultAreaId}`, { replace: true });
		}, 50);
	};

	return (
		<Grid2 container alignItems="flex-end" spacing={1}>
			<Grid2 size={{ lg: 2, md: 6, xs: 12 }}>
				<StartFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 6, xs: 12 }}>
				<EndFilter />
			</Grid2>
			<Grid2 size={{ lg: 1, md: 6, xs: 12 }}>
				<SearchFilter onKeyDown={onKeyDown} />
			</Grid2>
			<Grid2 size={{ lg: 1, md: 6, xs: 12 }}>
				<StatusFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 6, xs: 12 }}>
				<CraftsFilter />
			</Grid2>
			<Grid2 size={{ lg: 1, md: 6, xs: 12 }}>
				<TypesFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 6, xs: 12 }}>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						marginTop: "8px",
						marginBottom: "4px",
					}}
				>
					<ExpiredFilter />
				</Box>
			</Grid2>
			<Grid2 size={{ lg: 1, md: 6, xs: 12 }}>
				<Box sx={{ marginTop: "8px", marginBottom: "4px" }}>
					<Button
						fullWidth
						variant="contained"
						color="inherit"
						onClick={resetFilter}
						sx={{ height: "40px" }}
					>
						RESET
					</Button>
				</Box>
			</Grid2>
		</Grid2>
	);
};
